import { render, staticRenderFns } from "./MtiporesolucionGrid.vue?vue&type=template&id=667b2f58"
import script from "./MtiporesolucionGrid.vue?vue&type=script&lang=js"
export * from "./MtiporesolucionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports